import React, { useEffect, useMemo, useState } from "react";
import { useOutletContext } from "react-router-dom";
import "./HomeComponent.scss";

import AboutComponent from "../AboutComponent/AboutComponent";
import FeaturesComponent from "../FeaturesComponent/FeaturesComponent";
import ChoosingComponent from "../ChoosingComponent/ChoosingComponent";
import ContactComponent from "../ContactComponent/ContactComponent";
import TestimonialComponent from "../TestimonialComponent/TestimonialComponent";
import TrailComponent from "../TrailComponent/TrailComponent";
import HowItWorksComponent from "../HowItWorksComponent/HowItWorksComponent";
import homeImage from "./homeimage.jpg";
import PricingComponent from "../PricingComponent/PricingComponent";

const HomeComponent = ({ weddingData: weddingDataProp }) => {
  const outletContext = useOutletContext?.() || {};
  const weddingData = weddingDataProp || outletContext?.weddingData || {};

  const uploadedBannerImage = useMemo(() => {
    const gallery = weddingData?.imageGallery;

    if (gallery && !Array.isArray(gallery) && typeof gallery === "object") {
      return (
        gallery.signatureBannerImage ||
        gallery.mainImage ||
        gallery.bannerImage ||
        ""
      );
    }

    if (Array.isArray(gallery)) {
      return (
        gallery?.[0]?.image ||
        gallery?.find((item) => item?.key === "signatureBannerImage")?.image ||
        gallery?.find((item) => item?.key === "mainImage")?.image ||
        ""
      );
    }

    return weddingData?.bannerImage || "";
  }, [weddingData]);

  const [heroBackground, setHeroBackground] = useState(homeImage);

  useEffect(() => {
    if (!uploadedBannerImage) {
      setHeroBackground(homeImage);
      return;
    }

    let isMounted = true;
    const preloadImage = new Image();

    preloadImage.onload = () => {
      if (isMounted) {
        setHeroBackground(uploadedBannerImage);
      }
    };

    preloadImage.onerror = () => {
      if (isMounted) {
        setHeroBackground(homeImage);
      }
    };

    preloadImage.src = uploadedBannerImage;

    return () => {
      isMounted = false;
    };
  }, [uploadedBannerImage]);

  return (
    <div className="pmg-home-page">
      <section
        id="home"
        className="pmg-home-hero"
        style={{ backgroundImage: `url(${heroBackground})` }}
      >
        <div className="pmg-home-hero__overlay" aria-hidden="true" />

        <div className="pmg-home-hero__content">
          <h1 className="pmg-home-hero__title">
            <span className="pmg-home-hero__titleMain">The Future</span>
            <span className="pmg-home-hero__titleSub">
              of Guest Management Is Here.
            </span>
          </h1>

          <p className="pmg-home-hero__text">
            <strong>Plan My Guest - </strong>
            Plan Smart. Celebrate Beautifully. Create a modern wedding website,
            manage guests by family, track RSVPs, assign tables, and relax.
            We’ll handle the details.
          </p>

          <div className="pmg-home-hero__actions">
            <a
              href="/signup"
              target="_blank"
              rel="noopener noreferrer"
              className="pmg-home-hero__button pmg-home-hero__button--primary"
            >
              Start Free Trial
            </a>

            <a
              href="https://www.planmyguest.com/sites/vishmi-sanjana"
              target="_blank"
              rel="noopener noreferrer"
              className="pmg-home-hero__button pmg-home-hero__button--secondary"
            >
              View Demo Website
            </a>

            <a
              href="/login"
              target="_blank"
              rel="noopener noreferrer"
              className="pmg-home-hero__button pmg-home-hero__button--secondary"
            >
              Guest Login
            </a>
          </div>
        </div>
      </section>

      <AboutComponent />
      <TrailComponent />
      <FeaturesComponent />
      <PricingComponent/>
      <ChoosingComponent />
      <TestimonialComponent />
      <HowItWorksComponent />
      <ContactComponent />
    </div>
  );
};

export default HomeComponent;